import React from "react";
import { withRouter } from "react-router";
import cx from "clsx";
import ReportsList from "./BusinessInsightsContent/ReportsList";
import SalesSummary from "./BusinessInsightsContent/Reports/SalesSummary/SalesSummary";
import TotalSales from "./BusinessInsightsContent/Reports/TotalSales/TotalSales";
import NetSales from "./BusinessInsightsContent/Reports/NetSales/NetSales";
import MembershipSales from "./BusinessInsightsContent/Reports/MembershipSales/MembershipSales";
import ProductSales from "./BusinessInsightsContent/Reports/ProductSales/ProductSales";
import CategorySales from "./BusinessInsightsContent/Reports/CategorySales/CategorySales";
import PackageSales from "./BusinessInsightsContent/Reports/PackageSales/PackageSales";
import PricingVariationsSales from "./BusinessInsightsContent/Reports/PricingVariationsSales/PricingVariationsSales";
import Discounts from "./BusinessInsightsContent/Reports/Discount/Discounts";
import Commissions from "./BusinessInsightsContent/Reports/Commissions/Commissions";
import TipsPerProvider from "./BusinessInsightsContent/Reports/TipsPerProvider/TipsPerProvider";
import CancellationFees from "./BusinessInsightsContent/Reports/CancellationFees/CancellationFees";
import RetailReport from "./BusinessInsightsContent/Reports/RetailReport/RetailReport";
import ServicesPerformed from "./BusinessInsightsContent/Reports/ServicesPerformed/ServicesPerformed";
import BdAspire from "./BusinessInsightsContent/Reports/BdAspire/BdAspire";
import Refunds from "./BusinessInsightsContent/Reports/Refunds/Refunds";
import EGiftCardRevenue from "./BusinessInsightsContent/Reports/EgiftCardRevenue/EGiftCardRevenue";
import EgiftSales from "./BusinessInsightsContent/Reports/EgiftSales/EgiftSales";
import PaymentMethods from "./BusinessInsightsContent/Reports/PaymentMethods/PaymentMethods";
import Taxes from "./BusinessInsightsContent/Reports/Taxes/Taxes";
import TreatmentPlans from "./BusinessInsightsContent/Reports/TreatmentPlans/TreatmentPlans";
import { ShortTermLiability } from "./BusinessInsightsContent/Reports/ShortTermLiability/ShortTermLiability";
import StaffTreatment from "./BusinessInsightsContent/Reports/StaffTreatment/StaffTreatment";
import StaffAsPatients from "./BusinessInsightsContent/Reports/StaffAsPatients/StaffAsPatients";
import CostToCompany from "./BusinessInsightsContent/Reports/CostToCompany/CostToCompany";
import MembershipFeesDetail from "./BusinessInsightsContent/Reports/MembershipFeesDetail/MembershipFeesDetail";
import SetupFeesDetail from "./BusinessInsightsContent/Reports/SetupFeesDetail/SetupFeesDetail";
import NewMembersDetail from "./BusinessInsightsContent/Reports/NewMembersDetail/NewMembersDetail";
import ActiveMembersDetail from "./BusinessInsightsContent/Reports/ActiveMembersDetail/ActiveMembersDetail";
import CancelledMembersDetail from "./BusinessInsightsContent/Reports/CancelledMembersDetail/CancelledMembersDetail";
import { Box } from "../../shared/Box/Box";
import MembershipOverviewReport from "./BusinessInsightsContent/Reports/MembershipOverviewReport/MembershipOverviewReport";
import { MembershipChurnReport } from "./BusinessInsightsContent/Reports/MembershipChurnReport/MembershipChurnReport";
import { MembershipDeclineReport } from "./BusinessInsightsContent/Reports/MembershipDeclineReport/MembershipDeclineReport";
import EGiftCards from "./BusinessInsightsContent/Reports/eGiftcards/EGiftCards";
import AspireRedemptionReport from "./BusinessInsightsContent/Reports/AspireRedemptionReport/AspireRedemptionReport";
import RepeatMdRedemptionReport from "./BusinessInsightsContent/Reports/RepeatMdRedemptionReport/RepeatMdRedemptionReport";
import JoyaRedemptionReport from "./BusinessInsightsContent/Reports/JoyaRedemptionReport/JoyaRedemptionReport";
import PatientWalletLiability from "./BusinessInsightsContent/Reports/PatientWalletLiability/PatientWalletLiability";
import RetailSales from "./BusinessInsightsContent/Reports/RetailSales/RetailSales";
import DiscountsReport from "./BusinessInsightsContent/Reports/DiscountsReport/DiscountsReport";
import WalletDebits from "./BusinessInsightsContent/Reports/WalletDebits/WalletDebits";
import WalletCredits from "./BusinessInsightsContent/Reports/WalletCredits/WalletCredits";
import TotalSalesSummary from "./BusinessInsightsContent/Reports/TotalSalesSummary/TotalSalesSummary";
import TotalSalesSummaryV2 from "./BusinessInsightsContent/Reports/TotalSalesSummary/TotalSalesSummaryV2";
import NetRevenueSummaryV2 from "./BusinessInsightsContent/Reports/NetRevenueSummary/NetRevenueSummaryV2";
import TotalDiscountSummaryV2 from "./BusinessInsightsContent/Reports/TotalDiscountSummary/TotalDiscountSummaryV2";
import NetSalesReportV2 from "./BusinessInsightsContent/Reports/NetSalesReport/NetSalesReportV2";
import TotalSalesV2 from "./BusinessInsightsContent/Reports/TotalSales/TotalSalesV2";
import MembershipSalesV2 from "./BusinessInsightsContent/Reports/MembershipSales/MembershipSalesV2";
import EgiftSalesV2 from "./BusinessInsightsContent/Reports/EgiftSales/EgiftSalesV2";
import RetailSalesV2 from "./BusinessInsightsContent/Reports/RetailSales/RetailSalesV2";
import DiscountsReportV2 from "./BusinessInsightsContent/Reports/DiscountsReport/DiscountsReportV2";
import WalletDebitsV2 from "./BusinessInsightsContent/Reports/WalletDebits/WalletDebitsV2";
import WalletCreditsV2 from "./BusinessInsightsContent/Reports/WalletCredits/WalletCreditsV2";
import TotalDiscountSummary from "./BusinessInsightsContent/Reports/TotalDiscountSummary/TotalDiscountSummary";
import NetRevenueSummary from "./BusinessInsightsContent/Reports/NetRevenueSummary/NetRevenueSummary";
import NetSalesReport from "./BusinessInsightsContent/Reports/NetSalesReport/NetSalesReport";

const NewBusinessInsightsContent = ({ match }) => {
  const reports = {
    daily_sales_report: { title: "Sales Summary", component: <SalesSummary /> },
    total_sales_summary: {
      title: "Total Sales Summary Report New",
      component: <TotalSalesSummary />,
    },
    total_sales_summary_v2: {
      title: "Total Sales Summary Report V2",
      component: <TotalSalesSummaryV2 />,
    },
    net_revenue_summary_v2: {
      title: "Net Revenue Summary Report V2",
      component: <NetRevenueSummaryV2 />,
    },
    total_discount_summary_v2: {
      title: "Total Discount Summary Report V2",
      component: <TotalDiscountSummaryV2 />,
    },
    net_sales_report_v2: {
      title: "Net Sales Report V2",
      component: <NetSalesReportV2 />,
    },
    total_sales_report_v2: {
      title: "Total Sales Report V2",
      component: <TotalSalesV2 />,
    },
    membership_sales_v2: {
      title: "Membership Sales V2",
      component: <MembershipSalesV2 />,
    },
    egift_sales_v2: {
      title: "eGift Sales V2",
      component: <EgiftSalesV2 />,
    },
    retail_sales_v2: {
      title: "Retail Sales V2",
      component: <RetailSalesV2 />,
    },
    discounts_report_v2: {
      title: "Discounts Report V2",
      component: <DiscountsReportV2 />,
    },
    wallet_debits_v2: {
      title: "Wallet Debits V2",
      component: <WalletDebitsV2 />,
    },
    wallet_credits_v2: {
      title: "Wallet Credits V2",
      component: <WalletCreditsV2 />,
    },
    total_discount_summary: {
      title: "Total Discount Summary Report",
      component: <TotalDiscountSummary />,
    },
    net_revenue_summary: {
      title: "Net Revenue Summary Report",
      component: <NetRevenueSummary />,
    },
    net_sales_report: {
      title: "Net Sales Report",
      component: <NetSalesReport />,
    },
    gross_sales: { title: "Total Sales", component: <TotalSales /> },
    net_sales: { title: "Net Sales", component: <NetSales /> },
    membership_sales: {
      title: "Membership Sales",
      component: <MembershipSales />,
    },
    retail_sales: {
      title: "Retail Sales",
      component: <RetailSales />,
    },
    item_sales: { title: "Product Sales", component: <ProductSales /> },
    category_sales: { title: "Category Sales", component: <CategorySales /> },
    package_sales: { title: "Package Sales", component: <PackageSales /> },
    iv_package_sales: {
      title: "Pricing Variations Sales",
      component: <PricingVariationsSales />,
    },
    discounts: { title: "Discounts", component: <Discounts /> },
    commission_report: { title: "Commissions", component: <Commissions /> },
    tip_report: { title: "Tips Per Provider", component: <TipsPerProvider /> },
    cancellation_fees: {
      title: "Cancellation Fees",
      component: <CancellationFees />,
    },
    retail_report: { title: "Retail Report", component: <RetailReport /> },
    services_performed: {
      title: "Services Performed",
      component: <ServicesPerformed />,
    },
    bd_aspire_report: { title: "Services Performed", component: <BdAspire /> },
    refunds_report: { title: "Refunds", component: <Refunds /> },
    egift_cards: {
      title: "eGift Cards",
      component: <EGiftCards />,
    },
    egift_cards_revenue: {
      title: "eGift Card Revenue",
      component: <EGiftCardRevenue />,
    },
    egift_sales: {
      title: "eGift Sales",
      component: <EgiftSales />,
    },
    payment_methods: {
      title: "Payment Methods",
      component: <PaymentMethods />,
    },
    taxes: { title: "Taxes", component: <Taxes /> },
    treatment_plans: {
      title: "Treatment Plans",
      component: <TreatmentPlans />,
    },
    short_term_liability: {
      title: "Short Term Liability",
      component: <ShortTermLiability />,
    },
    staff_treatments: {
      title: "Staff Treatment",
      component: <StaffTreatment />,
    },
    staff_as_patients: {
      title: "Staff as Patients",
      component: <StaffAsPatients />,
    },
    cost_to_company: { title: "Cost To Company", component: <CostToCompany /> },
    membership_overview: {
      title: "Membership Dashboard",
      component: <MembershipOverviewReport />,
    },
    membership_fees_detail: {
      title: "Membership Fees Detail",
      component: <MembershipFeesDetail />,
    },
    setup_fees_detail: {
      title: "Setup Fees Detail",
      component: <SetupFeesDetail />,
    },
    new_members_detail: {
      title: "New Members Detail",
      component: <NewMembersDetail />,
    },
    active_members_detail: {
      title: "Active Members Detail",
      component: <ActiveMembersDetail />,
    },
    cancelled_members_detail: {
      title: "Cancelled Members Detail",
      component: <CancelledMembersDetail />,
    },
    membership_churn_report: {
      title: "Membership Churn Report",
      component: <MembershipChurnReport />,
    },
    membership_decline_report: {
      title: "Membership Decline Report",
      component: <MembershipDeclineReport />,
    },
    redeemed_aspire_certificates: {
      title: "Redeemed Aspire Certificates",
      component: <AspireRedemptionReport />,
    },
    repeatmd_redemption: {
      title: "RepeatMD Redemption",
      component: <RepeatMdRedemptionReport />,
    },
    joya_redemption: {
      title: "Joya Redemption",
      component: <JoyaRedemptionReport />,
    },
    discounts_report: {
      title: "Discounts Report",
      component: <DiscountsReport />,
    },
    wallet_debits: {
      title: "Wallet Debits",
      component: <WalletDebits />,
    },
    wallet_credits: {
      title: "Wallet Credits",
      component: <WalletCredits />,
    },
    patient_wallet_liability: {
      title: "Patient Wallet Liability",
      component: <PatientWalletLiability />,
    },
  };

  return (
    <div className="full-width membership-title flex-col">
      {!match.params.report ? (
        <>
          <Box
            className={cx(
              "m-b-20 membership-title flex justify-between items-center",
            )}
          >
            Sales
          </Box>
          <ReportsList />
        </>
      ) : (
        <div>{reports[match.params.report]["component"]}</div>
      )}
    </div>
  );
};

export default withRouter(NewBusinessInsightsContent);
